/* import __COLOCATED_TEMPLATE__ from './heatmap.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
/* eslint-disable @intercom/intercom/no-bare-strings -- days/hours not yet translated, see reporting.chart-heatmap.* for existing i18n keys */
import Component from '@glimmer/component';

const days = ['Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays', 'Sundays'];

const HOUR_LABELS = [
  '12am',
  '1am',
  '2am',
  '3am',
  '4am',
  '5am',
  '6am',
  '7am',
  '8am',
  '9am',
  '10am',
  '11am',
  '12pm',
  '1pm',
  '2pm',
  '3pm',
  '4pm',
  '5pm',
  '6pm',
  '7pm',
  '8pm',
  '9pm',
  '10pm',
  '11pm',
];

export default class HeatmapChart extends Component {
  get maxBucket() {
    return this.args.signal?.maxBucket;
  }

  get maxDay() {
    return days[this.maxBucket?.outerKey - 1];
  }

  get maxHours() {
    return HOUR_LABELS[this.maxBucket?.key] ?? '';
  }
}
